import PropTypes from 'prop-types'
import { createContext, useContext, useState } from 'react'
import i18n, { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY } from 'i18n'

// Crea un contexto para gestionar el idioma seleccionado en el panel
export const LanguageContext = createContext(null)

// Proveedor del contexto de idioma. Envuelve los componentes hijos y expone el
// idioma actual junto con la función para cambiarlo (persistida en localStorage
// y sincronizada con i18next).
export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(i18n.language || DEFAULT_LANGUAGE)

  const setLanguage = (lang) => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) return
    i18n.changeLanguage(lang)
    try {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
    } catch {
      // localStorage no disponible (modo privado, etc.) - el idioma sigue
      // funcionando en esta sesión, simplemente no se recuerda entre visitas.
    }
    setLanguageState(lang)
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage, supportedLanguages: SUPPORTED_LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  )
}

// Hook personalizado para usar el contexto de idioma de forma más sencilla
export const useLanguage = () => useContext(LanguageContext)

// Define los tipos de las props que recibe el componente actual
LanguageProvider.propTypes = {
  children: PropTypes.any
}
